export default "__VITE_ASSET__e48dedd9__"